import { createSlice } from "@reduxjs/toolkit";

const facilitySlice = createSlice({
  name: "facility",
  initialState: [],
  reducers: {
    facilityAdd(state, action) {
      return action.payload || [];
    },
    specificFacilityAdd(state, action) {
      const facility = action.payload;
      if (!facility) {
        return;
      }
      const facilityIndex = state.findIndex(item => item.id === facility.id);
      if (facilityIndex === -1) {
        state.push(facility);
      } else {
        state[facilityIndex] = facility;
      }
    },
    facilityEdit(state, action) {
      const facility = action.payload;
      if (!facility) {
        return;
      }
      const facilityIndex = state.findIndex(item => item?.id === facility.id);
      if (facilityIndex !== -1) {
        state[facilityIndex] = facility;
      }
    },
    // Merges the changed fields into a stored facility, keeping what the answer doesn't carry
    // (its contact persons, company, prequalifications, …)
    facilityPatch(state, action) {
      const patch = action.payload;
      if (!patch?.id) {
        return;
      }
      const facility = state.find(item => item?.id === patch.id);
      if (facility) {
        Object.assign(facility, patch);
      }
    },
    facilityCreate(state, action) {
      const facility = action.payload?.facility;
      if (facility) {
        state.push(facility);
      }
    },
    facilityDelete(state, action) {
      const facilityIndex = state.findIndex(item => item.id === action.payload);
      if (facilityIndex !== -1) {
        state.splice(facilityIndex, 1);
      }
    },
  },
});

export const {
  facilityAdd,
  specificFacilityAdd,
  facilityEdit,
  facilityPatch,
  facilityCreate,
  facilityDelete,
} = facilitySlice.actions;
export default facilitySlice.reducer;
